export default {
  WHEN_CLICKED: 1,
  NEVER: 2,
};



// WEBPACK FOOTER //
// ./src/widget/player-widget/constants/default-settings/compact-show-video-list.js